import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import { useAudiencesCRUDActions } from '@mm/state/actions/AudiencesCRUDActions';

export const useFetchAudience = (audienceId: number) => {
  const activeChatbotId = useSelector(activeChatbotIdSelector);
  const { retrieveAudienceById } = useAudiencesCRUDActions();

  useEffect(() => {
    if (audienceId && activeChatbotId) {
      retrieveAudienceById(activeChatbotId, audienceId);
    }
  }, [activeChatbotId, audienceId]);
};
